import React from 'react';
import { formatoDecimal } from "../../../../utilities/formatoNumeros";
import Spinner from 'react-bootstrap/Spinner';

export default class RebatesDeLiquidacion extends React.Component {
  getRebatesValidos = () => {
    const { detalleRebate } = this.props;

    if (!detalleRebate || detalleRebate.length === 0) return [];

    return detalleRebate.flatMap(detalle =>
      detalle.listRebates?.length > 0
        ? detalle.listRebates.map(r => ({ ...r, idVenta: detalle.idVenta }))
        : []
    );
  };

  render = () => {
    const rebatesValidos = this.getRebatesValidos();

    if (this.props.isLoading) {
      return (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      );
    }

    if (rebatesValidos.length === 0) {
      return (
        <div className="card">
          <div className="card-body">
            <div className="row justify-content-center align-items-center p-10">
              No hay rebates para esta liquidación
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="row justify-content-center align-items-center p-10">
        <h5 className="col-auto">Rebates</h5>

        <div className="list-group-item col-12 animated fadeIn">
          <div className="table-responsive card">
            <table className="table">
              <thead>
                <tr>
                  <th><small>Id Rebate</small></th>
                  <th><small>Id Venta</small></th>
                  <th><small>Precio Original</small></th>
                  <th><small>Precio Publicado</small></th>
                  <th><small>Rebate Megatone</small></th>
                  <th><small>Rebate Seller</small></th>
                </tr>
              </thead>
              <tbody>
                {rebatesValidos.map((rebate, index) => (
                  <tr key={`${rebate.idVenta}-${rebate.idRebate}-${index}`} className="hover-background-color">
                    <td><small>{rebate.idRebate}</small></td>
                    <td><small>{rebate.idVenta}</small></td>
                    <td><small>${formatoDecimal(rebate.precioOriginal)}</small></td>
                    <td><small>${formatoDecimal(rebate.precioPublicado)}</small></td>
                    <td><small>${formatoDecimal(rebate.rebateMegatone)}</small></td>
                    <td><small>${formatoDecimal(rebate.rebateSeller)}</small></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };
}

